import React, { useCallback, useReducer, useState } from "react"
import { obterRankingClientes } from "../../../services/posicaoClientes"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { PosicaoClientesInicial } from "../models/posicaoClientesModel"
import { PosicaoClientesActionsTypes } from "./posicaoClientesActions"
import { PosicaoClientesContext } from "./PosicaoClientesContext"
import { posicaoClientesReducer } from "./posicaoClientesReducer"

export function PosicaoClientesContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(posicaoClientesReducer, PosicaoClientesInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const pesquisar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterRankingClientes(autorizacao, dados.filtro)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar ranking")
            } else {
                setErroCarregamento(null)
                dispatch({ type: PosicaoClientesActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar ranking")
        } finally {
            setLoading(false)
        }
    }, [dados.filtro, setLoading])

    return (
        <PosicaoClientesContext.Provider value={{ dados, dispatch, pesquisar, erroCarregamento }}>
            <Loading />
            {children}
        </PosicaoClientesContext.Provider>
    )
}
